import { makeStyles } from "@material-ui/core/styles"

const backgroundImageUrl = "http://2-im.guokr.com/4hKmkrGljrC6Aj1LD5Fo5p9TmqpIxqf02aJOd8ybd7pXEwAAAQ0AAEpQ.jpg"

export const useLoginStyle = makeStyles((theme) => ({
    "@global": {
        "#root": {
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
        },
    },
    backgroundImage: {
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: -1,
        backgroundImage: `url('${backgroundImageUrl}')`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        height: "100%",
        width: "100%",
        // filter: "blur(1px)",
    },
    container: {
        transform: "translateY(-120px)",
        opacity: 0,
        transition: "transform .4s linear, opacity .4s linear",
    },
    containerShow: {
        transform: "translateY(0)",
        opacity: 1,
        transition: "transform .4s linear, opacity .4s linear",
    },
    "paper": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: theme.spacing(4),
        borderRadius: 12,
        backgroundColor: "rgba(255,255,255, .70)",
    },
    "form": {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
        padding: theme.spacing(1),
    },
    "input": {
        borderRadius: theme.shape.borderRadius,
    },
    "submit": {
        margin: theme.spacing(3, 0, 2),
    },
    "logo": {
        width: 140,
    },
}))
